import { AttackPathApi } from "@kdmanalytics/brm-system";
import BrmApiClient from "services/brm/BrmApiClient";

const attackPathApi = new AttackPathApi(BrmApiClient.instance);

export default attackPathApi;
